import React, { useMemo } from 'react';
import { useApp } from '@context/AppContext';
import { PageTitleBanner } from '@goodfynd/layout';
import { LoadingTruck } from '@goodfynd/ui';
import { useRequireAuth } from '@hooks/useRequireAuth';

import { useOrganization } from '../../../context/OrganizationContext';
import Footer from '../Footer';
import Header from '../Header';
import { LoadingFullPage } from '../LoadingFullPage';

import type { LayoutWithHeaderProps } from './types';

import classes from './LayoutWithHeader.module.css';

export function LayoutWithOrganizationHeader({
  bannerContainerCss,
  children,
  showOrganizationName,
  authRequired,
  allowedRoles,
  ...props
}: LayoutWithHeaderProps): JSX.Element {
  const isLoggedIn = useRequireAuth({ allowedRoles, authRequired });
  const { userIsLoading } = useApp();
  const { isLoading: orgIsLoading, organization } = useOrganization();
  const isLoading = useMemo(
    () => orgIsLoading || userIsLoading,
    [orgIsLoading, userIsLoading]
  );

  const subtitle = useMemo(() => {
    return showOrganizationName ? organization.name : props.bannerSubTitle;
  }, [organization.name, props.bannerSubTitle, showOrganizationName]);

  if (authRequired && !isLoggedIn) {
    return <></>;
  }

  return (
    <div className={classes['page-container']} style={{ paddingTop: 64 }}>
      <Header />
      <>
        {typeof props.bannerTitle === 'string' ? (
          <PageTitleBanner
            containerCss={bannerContainerCss}
            subtitle={subtitle}
            title={props.bannerTitle}
          />
        ) : (
          props.bannerTitle
        )}

        {isLoading ? (
          <LoadingFullPage>
            <LoadingTruck />
          </LoadingFullPage>
        ) : (
          children
        )}
      </>
      <Footer />
    </div>
  );
}
